module.exports = __webpack_public_path__ + "assets/img/cda686b3b70d40aa024f80d5d77879cf.png";